import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';

const CierreFilters = ({
  fechaInicio,
  fechaTermino,
  onFechaInicioChange,
  onFechaTerminoChange,
  onClearFilters,
  loading
}) => {
  const [rangoTemporal, setRangoTemporal] = useState('');

  // Aplicar rango temporal predefinido
  const aplicarRangoTemporal = (rango) => {
    const hoy = new Date();
    let inicio, termino;

    switch (rango) {
      case 'ultima_semana':
        termino = new Date(hoy);
        inicio = new Date(hoy.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case 'ultimo_mes':
        termino = new Date(hoy);
        inicio = new Date(hoy.getFullYear(), hoy.getMonth() - 1, hoy.getDate());
        break;
      case 'ultimos_3_meses':
        termino = new Date(hoy);
        inicio = new Date(hoy.getFullYear(), hoy.getMonth() - 3, hoy.getDate());
        break;
      case 'mes_actual':
        inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        termino = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
        break;
      case 'mes_anterior':
        inicio = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
        termino = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
        break;
      default:
        return;
    }

    const formatFecha = (fecha) => fecha.toISOString().split('T')[0];
    onFechaInicioChange(formatFecha(inicio));
    onFechaTerminoChange(formatFecha(termino));
    setRangoTemporal(rango);
  };

  // Limpiar filtros
  const handleClearFilters = () => {
    onClearFilters();
    setRangoTemporal('');
  };

  return (
    <Card className="mb-4">
      <Card.Body>
        <Row className="align-items-end">
          <Col xs={12} md={3}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaIcons.FaCalendarAlt className="me-2" />
                Fecha Inicio
              </Form.Label>
              <Form.Control
                type="date"
                value={fechaInicio}
                onChange={(e) => {
                  onFechaInicioChange(e.target.value);
                  setRangoTemporal('');
                }}
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={3}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaIcons.FaCalendarAlt className="me-2" />
                Fecha Término
              </Form.Label>
              <Form.Control
                type="date"
                value={fechaTermino}
                onChange={(e) => {
                  onFechaTerminoChange(e.target.value);
                  setRangoTemporal('');
                }}
                disabled={loading}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={4}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaIcons.FaClock className="me-2" />
                Rangos Rápidos
              </Form.Label>
              <Form.Select
                value={rangoTemporal}
                onChange={(e) => aplicarRangoTemporal(e.target.value)}
                disabled={loading}
              >
                <option value="">Seleccionar rango...</option>
                <option value="ultima_semana">Última semana</option>
                <option value="ultimo_mes">Último mes</option>
                <option value="ultimos_3_meses">Últimos 3 meses</option>
                <option value="mes_actual">Mes actual</option>
                <option value="mes_anterior">Mes anterior</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md={2}>
            <div className="d-flex gap-2 mb-3">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleClearFilters}
                disabled={loading}
                title="Limpiar filtros"
                style={{ width: '32px', height: '32px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                <FaIcons.FaTimes size={14} />
              </Button>
            </div>
          </Col>
        </Row>

        {(fechaInicio || fechaTermino) && (
          <Row>
            <Col xs={12}>
              <div className="d-flex align-items-center gap-2 text-muted">
                <FaIcons.FaFilter size={14} />
                <small>
                  Filtros activos:
                  {fechaInicio && <span className="ms-2 badge bg-light text-dark">Desde: {fechaInicio}</span>}
                  {fechaTermino && <span className="ms-2 badge bg-light text-dark">Hasta: {fechaTermino}</span>}
                </small>
              </div>
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

CierreFilters.propTypes = {
  fechaInicio: PropTypes.string,
  fechaTermino: PropTypes.string,
  onFechaInicioChange: PropTypes.func.isRequired,
  onFechaTerminoChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

CierreFilters.defaultProps = {
  fechaInicio: '',
  fechaTermino: '',
  loading: false
};

export default CierreFilters;
